import { Component, OnInit } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { ResponsiveService } from '../shared/responsive/responsive.service';
import { NavigationService } from '../shared/services/navigation.service';
import * as constant from './../shared/constants/constants';
import { UtilService } from '../shared/services/util.service';
import { ExceptionService } from '../shared/services/exception.service';
import { StorageService } from '../shared/services/storage.service';
import { NotificationService } from '../shared/services/notification.service';
import { country_name, dahsboardIcon, localStorageKeys, role_name, translate_enum } from '../core/enum';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  /** component data variable */
  dashboard_data : any = []
  user_name : any =''
  role_name : any = ''
  notification_available: any = false;
  notification_visible : any = true;
  notification_icon:any = false;
  market_options:any = this.util.marketArray;
  selected_market:any ;
  market_icon :any = dahsboardIcon
  private role_id_trigger: Subscription;
  country_name:any = country_name


  constructor(
    public responsiveService: ResponsiveService,
    private apiService: ApiService,
    private navigationService: NavigationService,
    private util: UtilService,
    public exceptionService: ExceptionService,
    private storageService: StorageService,
    private notificationService: NotificationService,
    private translateService: TranslateService
  ) { 
    this.notificationService.triggerNotificationSymbol.subscribe((value:any)=>{
     this.notification_available = value;
    })
  }

  async ngOnInit() {
    this.util.key_trigger.subscribe(async () => {
        this.market_options = this.util.marketArray;
        this.selected_market = this.market_options.length == 1 ? this.market_options[0] : await this.storageService.get(localStorageKeys.market)
        if (this.selected_market) {
          this.onMarketChange(true)
        }
        this.getUserDetailsAPICall();
    })
  }
  /** Api for Getting Configuration */
  getConfiguration() {
    this.apiService.getConfiguration().subscribe({
      next: (response: any) => {
        this.storageService.set(constant.storage_keys.configuration, response.data);
      },
      error: (error: any) => {
        this.exceptionService.toastMessage(error.status, error.body);
      }
    })
  }

  /** Get User Details API Call */
  async getUserDetailsAPICall() {
    this.user_name = await this.storageService.get(constant.storage_keys.user_name);
    let role_id  = await this.storageService.get(constant.storage_keys.role_id);
    this.role_name = role_name[role_id];
  }

  /** Api call function for Navigation Data */
 async getMenuData() {
    this.navigationService.getMenuData(await this.menuDto()).subscribe((response: any) => {
      this.storageService.set(localStorageKeys.menu , response)
      this.handleMenuData(response)
      this.util.navigation_trigger.next(response)
    })
  }

  /** Handle Navigation Data */
  handleMenuData(response: any) {
    this.util.setNavigationCodes(response)
    this.dashboard_data = response.filter((data:any)=> data.navigation_code != constant.common.home_code);
    this.dashboard_data.forEach((value: any) => {
      value.link = constant.navigation.dashboardNavigation[value.navigation_code as keyof typeof constant.navigation.dashboardNavigation]
    })
  }

  /** Logout from the application */
  logout() {
    this.util.logout();
  }

  async menuDto(){
    const role_id = await this.storageService.get(constant.storage_keys.role_id)
    const payload =  {role_id: role_id}
    return payload
  }

  /**
   * open notification panel
   */
  notificationOpen(){
    this.util.notification_visible.next(this.notification_visible)
  }

async onMarketChange(initFlag:any = false) {
  const current_market = await this.storageService.get(localStorageKeys.market);
  this.storageService.set(localStorageKeys.market, this.selected_market)
  this.translateService.use(translate_enum[this.selected_market])
  if (this.selected_market === current_market && !initFlag) {
    return;
  }
  this.util.setMarketValue();
  if(this.role_id_trigger){
     this.role_id_trigger.unsubscribe();
  }
  this.role_id_trigger = this.util.role_id_trigger.subscribe((value) => {
    if (value) {
      this.getMenuData();
      this.getConfiguration();
      this.getUserDetailsAPICall();
      this.notification_icon = true;
      this.util.role_id_trigger.next(null)
    }
  })
}



}